/* istanbul ignore file */
import React, { useState, useRef, useEffect, useCallback, useReducer } from "react";
import { NavLink, withRouter } from "react-router-dom";
import ACTIONS from "../pages/DesignAssets/Design_Asset_Actions.json"
import ProjectBackgroundImage from "../images/EMB.png";
import Contact from "../pages/contact";
import ChangePassword from "../components/component/ChangePassword";
import GenerateReport from "../components/component/GenerateReport";
import AdminRoles from "../components/component/AdminRoles";

import useMountEffect from "../pages/CustomHooks/useMountEffect";
import userScope from "../pages/CustomHooks/userScope";
import configLabel from "../config/emb-labels-en.json";
import { useDispatch, useSelector } from "react-redux";
import APISESSION from "../api/ApiSession";
import { getProjectId } from "../utils/project";
import { shellLayoutConst } from "../utils/constants";
import { upDateProjectType } from "../redux/features/projectTypeSlice";
import { defaultProject, projectAtomList } from "../atoms";
import { useAtom } from "jotai";
import { isEmpty } from "lodash";
import { ComponentDataReducer, initialComponentData, useComponentData } from "../pages/DesignAssets/Reducers/ComponentDataReducer";
import { initialTypes, projectKindReducer } from "../pages/DesignAssets/Reducers/projectKindReducer";
import Snackbar from "../pages/SE-Component/Snackbar";
import env from "../env";
import { sendCommonEvent, sendNavClickEvent } from "../utils/gaHelper";
import HelpMenu from "../components/Help/helpMenu";

const apiSession = new APISESSION();
const src = "url(" + ProjectBackgroundImage + ")";
const privacyPolicy = `https://www.se.com/ww/en/about-us/legal/data-privacy.jsp`;

const FileDownload = require("js-file-download");

const ShellLayout = (props) => {
  const dispatch = useDispatch();
  const UserScope = userScope();
  const [routePathURI, setRoutePathURI] = useState("");
  const { projectId } = props.match.params;
  const [status, setStatus] = useState({
    reportReadyStatus: false,
    navStatus: true,
    enableAssetPage: false,
    enableProgramPage: false,
    enableSystemPage: false,
    enableSecureArchitecturePage: false,
    enableBOMPage: false,
    enableDeployPage: false,
  });
  const [popUpStatus, setPopUpStatus] = useState({
    changePasswordPopUpStatus: false,
    successChangePassword: false,
    modifiedDataAlertPopupStatus: false,
    modifiedDERDataAlertPopupStatus: false,
    openReportPopUp: false,
    loadingPopupStatus: false,
    adminRolePopStatus: false,
    logoutPopUpStatus: false,
  });
  const [modifiedStatus, setModifiedStatus] = useState({
    modifiedDataAlertAssetPopupStatus: false,
    modifiedDERName: "",
  });
  const [alertStatus, setAlertStatus] = useState({
    alertMessagePopupStatus: false,
    alertMessage: "",
  });
  const [currentProject, setCurrentProject] = useAtom(projectAtomList);

  const [reportStatus, setReportStatus] = useState({
    selectAll: false,
    information: false,
    bom: currentProject?.showBOM,
    deploy: currentProject?.showDeploy,
    sld: true,
    system: currentProject?.showSystems && currentProject?.showDeploy,
    program: currentProject?.showUseCase  && currentProject?.showSystems,
    showSeletOption: false,
    secureAC: false,
    loggedInUser: UserScope.name
  });
    const snackBarRef = useRef(null);
  const [snackBar, setSnackBar] = useState({ type: "", message: "" });
  const [clientType, seClientType] = useState("");
  const [darkData, setDarkData] = useState({
    themeType:"Light",
    color:"secondary"
  })
  const projectNavigationRef = useRef(null);
  const userNavigationRef = useRef(null);
  const libraryNavigationRef = useRef(null);
  const globalNavigationRef = useRef(null);
  const analyticsNavigationRef = useRef(null);
  const contactNavigationRef = useRef(null);
  const legalRef = useRef(null);
  const privacyRef = useRef(null);
  const [projectStatusData, setProjectStatusData] = useState();

  const [redirectAlert, setRedirectAlert] = useState({
    message: "",
    alertPopUpStatus: false,
    title: "",
    isRoute: false,
    routePath: "",
  });
  

  // useEffect(() => {

  //   sessionStorage.setItem("pType", null);
  //   sessionStorage.setItem("pname", null);
  //   sessionStorage.setItem("projectId", null);
  //   sessionStorage.setItem("projectKindType", null);
  //   sessionStorage.setItem(
  //     "projectType",
  //     JSON.stringify({ }));
  //   },[])

  useEffect(() => {
    setReportStatus((prevData) => ({
      ...prevData,
      bom: currentProject?.showBOM,
      deploy: currentProject?.showDeploy,
      sld: true,
      system: currentProject?.showSystems && currentProject?.showDeploy,
      program: currentProject?.showUseCase && currentProject?.showSystems,
    }));
  }, [currentProject]);

  const closeRedirectAlertPopup = useCallback(() => {
    setRedirectAlert({
      message: "",
      alertPopUpStatus: false,
      title: "",
      isRoute: false,
      routePath: "",
    });
    if (redirectAlert.isRoute) {
      let {
        children: {
          props: { history },
        },
      } = props;

      history.push({
        pathname: `${redirectAlert.routePath}`,
      });
    }
  }, [redirectAlert, props]);

  useEffect(() => {
    let projectData = {};
    // setLoading(true);
    if (projectId) {
      apiSession
        .getProject(projectId)
        .then((json) => {
          if(json){
          setCurrentProject((prevData) => ({
            ...prevData,
            project: json,
            timeSettingsValidated: json?.systemsTimeSyncPage,
            showAsset: json?.projectId,
            showUseCase: json?.deploymentReady,
            showSystems: !json?.programPage,
            showBOM:
              json?.systemsPage === false &&
              json?.systemsTimeSyncPage === true &&
              !json?.programPage,
            showDeploy:
              json?.systemsPage === false &&
              json?.systemsTimeSyncPage === true &&
              !json?.programPage,
          }));
          sessionStorage.setItem("pType", json?.projectTypeDisplayValue);
          sessionStorage.setItem("pname", json?.projectTypeDisplayValue);
          sessionStorage.setItem("projectId", json?.projectId);
          sessionStorage.setItem("projectKindType", json?.projectType);
          sessionStorage.setItem( "projectType",JSON.stringify({ projectTypeValue: json?.projectType }));
        }
        })
        .catch((error) => {
          console.log("ddd");
          if (error?.status === 404) {
            setRedirectAlert((prev) => ({
              message: "Invalid Project",
              alertPopUpStatus: true,
              title: "ALERT",
              isRoute: true,
              routePath: `/project`,
            }));
          }
        });
    }
  }, [projectId]);

 
  useMountEffect(() => {
    sessionStorage.setItem("deploymentReady", true);
    sessionStorage.setItem("programPage", false);
    sessionStorage.setItem("optimizationModified", false);
     sessionStorage.removeItem("projectSite");
    // sessionStorage.setItem("timeSyncValidate", true);
    setStatus((prevState) => ({ ...prevState, reportReadyStatus: false }));

    projectNavigationRef.current.addEventListener("didClick", () => {
      sendNavClickEvent("Hamberger Left Navigation", "Projects");
      navigateProject();
    });

    if (UserScope.access.getUsers === true) {
      userNavigationRef.current.addEventListener("didClick", () => {
        sendNavClickEvent("Hamberger Left Navigation", "User Management");
        navigateUser();
      });
    }

    if (UserScope.access.saveAssets === true) {
      libraryNavigationRef.current.addEventListener("didClick", () => {
        sendNavClickEvent("Hamberger Left Navigation", "Library Management");
        navigateLibrary();
      });
    }

    if (UserScope.access.globalParams === true) {
      globalNavigationRef.current.addEventListener("didClick", () => {
        sendNavClickEvent("Hamberger Left Navigation", "Global Parameters");
        navigateGlobals();
      });
    }

    if (UserScope.access.audit === true) {
      analyticsNavigationRef.current.addEventListener("didClick", () => {
        sendNavClickEvent("Hamberger Left Navigation", "Analytics");
        navigateAnalytics();
      });
    }

    if (UserScope.access.globalParams === true) {
      contactNavigationRef.current.addEventListener("didClick", (e) => {
        sendNavClickEvent("Hamberger Left Navigation", "Contact Us");
        navigateContactUs(e);
      });
    }
    legalRef.current.addEventListener("didClick", (e) => {
      sendNavClickEvent("Hamberger Left Navigation", "Legal");
    });
    privacyRef.current.addEventListener("didClick", () => {
      sendNavClickEvent("Hamberger Left Navigation", "Privacy Preferences");
      if (window.OneTrust) {
        window.OneTrust.ToggleInfoDisplay();
      } else {
        console.warn("OneTrust not available");
      }
      document.getElementById("app2-sidemenu").toggle();
    });
  }, []);

  const errorMessageHandler = () => {
    if (currentProject?.project && !currentProject?.project?.deploymentReady) {
      return {errorMessage: shellLayoutConst.VALIDATE_DER_ALERT, path: "assets"};
    } else if (currentProject?.project?.programPage) {
      return {errorMessage: shellLayoutConst.VALIDATE_USE_CASE_ALERT, path: "program"};
    } else if (currentProject?.project?.showSystems) {
      return {errorMessage: shellLayoutConst.VALIDATE_SYSTEMS_ALERT, path: "systems"};
    } else {
      return {errorMessage:shellLayoutConst.VALIDATE_DER_ALERT, path: "assets"};
    }
  };

  useEffect(() => {
    const errorHandle = errorMessageHandler()
    if (
      !isEmpty(currentProject?.project) &&
      [
        "/program/:projectId",
        "/systems/:projectId",
        "/bom/:projectId",
        "/deploy/:projectId",
      ].includes(props.match.path) &&
      !currentProject?.showUseCase
    ) {
      setRedirectAlert((prev) => ({
        ...prev,
        message: errorHandle?.errorMessage,
        alertPopUpStatus: true,
        title: "ALERT",
        isRoute: true,
        routePath: `/${errorHandle?.path}/${projectId}`,
      }));
    } else if (
      props.match.path === "/systems/:projectId" &&
      !isEmpty(currentProject?.project) &&
      !currentProject?.showSystems
    ) {
      setRedirectAlert((prev) => ({
        ...prev,
        message: errorHandle?.errorMessage,
        alertPopUpStatus: true,
        title: "ALERT",
        isRoute: true,
        routePath: `/${errorHandle?.path}/${projectId}`,
      }));
    } else if (
      ["/bom/:projectId", "/deploy/:projectId"].includes(props.match.path) &&
      !isEmpty(currentProject?.project) &&
      !currentProject?.showBOM
    ) {
      setRedirectAlert((prev) => ({
        ...prev,
        message: errorHandle?.errorMessage,
        alertPopUpStatus: true,
        title: "ALERT",
        isRoute: true,
        routePath: `/${errorHandle?.path}/${projectId}`,
      }));
    }
  }, [
    projectStatusData,
    currentProject?.project,
    props.children.props.history.location.pathname,
  ]);

  useEffect(() => {
    if (
      props?.children?.props?.history?.location?.pathname === "/project" ||
      props?.children?.props?.history?.location?.pathname === "/userdetails"
    ) {
      setStatus((prevState) => ({ ...prevState, navStatus: false }));
    } else {
      setStatus((prevState) => ({ ...prevState, navStatus: true }));

      resetEnable();
      if (
        props.children.props.history.location.pathname ===
        `/information/${projectId}`
      ) {
        // nothing
      } else if (
        props.children.props.history.location.pathname ===
        `/assets/${projectId}`
      ) {
        setStatus((prevState) => ({ ...prevState, enableAssetPage: true }));
      } else if (
        props.children.props.history.location.pathname ===
        `/program/${projectId}`
      ) {
        setStatus((prevState) => ({ ...prevState, enableProgramPage: true }));
      } else if (
        props.children.props.history.location.pathname ===
        `/systems/${projectId}`
      ) {
        setStatus((prevState) => ({ ...prevState, enableSystemPage: true }));
      } else if (
        props.children.props.history.location.pathname === "/secureArchitecture"
      ) {
        setStatus((prevState) => ({
          ...prevState,
          enableSecureArchitecturePage: true,
        }));
      } else if (
        props.children.props.history.location.pathname === `/bom/${projectId}`
      ) {
        setStatus((prevState) => ({ ...prevState, enableBOMPage: true }));
      } else if (
        props.children.props.history.location.pathname ===
        `/deploy/${projectId}`
      ) {
        setStatus((prevState) => ({ ...prevState, enableDeployPage: true }));
      }
    }
    return () => {
      if (
        ![
          `/deploy/${projectId}`,
          `/program/${projectId}`,
          `/bom/${projectId}`,
          `/information/${projectId}`,
          `/systems/${projectId}`,
          "/secureArchitecture",
          `/assets/${projectId}`,
        ].includes(props.children.props.history.location.pathname)
      ) {
        // dispatch(upDateProjectType({}));
        setCurrentProject(defaultProject);
      }
      // sessionStorage.setItem("pType", null);
      //     sessionStorage.setItem("pname", null);
      //     sessionStorage.setItem("projectId", null);
      //     sessionStorage.setItem("projectKindType", null);
      //     sessionStorage.setItem(
      //       "projectType",
      //       JSON.stringify({ }));
    };
  }, [props.children.props.history.location.pathname]);

  useEffect(() => {
    getProjectDetailStatus();
  }, [props.children.props.history.location.pathname]);
  const getProjectDetailStatus = () => {
    try {
      if (projectId) {
        apiSession
          .getProjectStatus(projectId)
          .then((response) => {
            if (response) {
              setProjectStatusData(response);
              setCurrentProject((prevData) => ({
                ...prevData,
                projectStatus: response,
              }));
              //  dispatch(upDateProjectType(response));
            }
          })

          .catch((error) => {
            if (error?.response?.status === 412) {
              callSnackbar("error", `${error?.message}`);
            }
          });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const navigateProject = () => {
    sessionStorage.setItem("selectedtab", "projects");
    sessionStorage.setItem("pname", null);
    sessionStorage.removeItem("projectSite");
    document.getElementById("app2-sidemenu").toggle();
    let {
      children: {
        props: { history },
      },
    } = props;
    dispatch(
      upDateProjectType({
        projectType: "",
        projectName: "",
      })
    );

    history.push({
      pathname: "/project",
    });
  };

  const navigateUser = () => {
    sessionStorage.setItem("selectedtab", "user");
    sessionStorage.setItem("pname", null);
    document.getElementById("app2-sidemenu").toggle();
    let {
      children: {
        props: { history },
      },
    } = props;

    history.push({
      pathname: "/project",
    });
  };

  const navigateLibrary = () => {
    sessionStorage.setItem("selectedtab", "asset");
    sessionStorage.setItem("pname", null);
    document.getElementById("app2-sidemenu").toggle();

    let {
      children: {
        props: { history },
      },
    } = props;

    history.push({
      pathname: "/project",
    });
  };

  const navigateGlobals = () => {
    sessionStorage.setItem("selectedtab", "globalparam");
    sessionStorage.setItem("pname", null);
    document.getElementById("app2-sidemenu").toggle();
    let {
      children: {
        props: { history },
      },
    } = props;

    history.push({
      pathname: "/project",
    });
  };

  const navigateAnalytics = () => {
    sessionStorage.setItem("selectedtab", "analytics");
    sessionStorage.setItem("pname", null);
    document.getElementById("app2-sidemenu").toggle();
    let {
      children: {
        props: { history },
      },
    } = props;

    history.push({
      pathname: "/project",
    });
  };

  const navigateContactUs = (e) => {};

  const redirectToProfile = () => {
    let {
      children: {
        props: { history },
      },
    } = props;

    history.push({
      pathname: "/userdetails",
    });
  };

  const onChangePassword = () =>
    setPopUpStatus((prevState) => ({
      ...prevState,
      changePasswordPopUpStatus: true,
    }));

  const closeChangePasswordPopUp = () =>
    setPopUpStatus((prevState) => ({
      ...prevState,
      changePasswordPopUpStatus: false,
    }));

  const onButtonLogout = () => {
    let {
      children: {
        props: { history },
      },
    } = props;
    sessionStorage.clear();
    apiSession
      .logout()
      .then((response) => {
        history.push({
          pathname: "/logout",
        });
      })
      .catch((error) => {
        history.push({
          pathname: "/logout",
        });
      });
    history.push({
      pathname: "/logout",
    });
  };

  const navigateToInformation = () => {
    let blockStatus = sessionStorage.getItem("assetEditStatus")?.split(",");
    // if (blockStatus[1] === "true") {
    //   blockStatusDisplay(true, blockStatus[0]);
    //   sessionStorage.setItem("page", "information");
    // } else 
    if (
      status.enableProgramPage === true &&
      sessionStorage.getItem("programDataModified") === "true"
    ) {
      sessionStorage.setItem("page","information")
      setPopUpStatus((prevState) => ({
        ...prevState,
        modifiedDataAlertPopupStatus: true,
      }));
      
    } else if (sessionStorage.getItem("componentDataModified") === "true" || blockStatus[1] === "true" ) {
      sessionStorage.setItem("page","information")
      setPopUpStatus(prevState => ({
        ...prevState,
        modifiedDERDataAlertPopupStatus: true,
        message:`Modified data is not saved. Do you want to save data? if yes, Modified
          data will be saved as draft.`
      }));
      setRoutePathURI("/information")
      
    }else {
      if (sessionStorage.getItem("processLoading") === "true") {
      } else {
        let {
          children: {
            props: { history },
          },
        } = props;
        history.push({
          pathname: `${"/information"}/${projectId}`,
        });
      }
    }
  };

  const navigateToAsset = () => {
    if (projectId) {
      if (
        status.enableProgramPage === true &&
        sessionStorage.getItem("programDataModified") === "true"
      ) {
        sessionStorage.setItem("page", "assets");
        setPopUpStatus((prevState) => ({
          ...prevState,
          modifiedDataAlertPopupStatus: true,
        }));
      } else {
        let {
          children: {
            props: { history },
          },
        } = props;
        history.push({
          pathname: `/assets/${projectId}`,
        });
      }
    } else {
      displayAlert(shellLayoutConst.PROJECT_ASSET_ALERT);
    }
  };

  const navigateToProgram = () => {
    if (
      projectStatusData?.projectStatus === "COMPLETED" ||
      projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
    ) {
      let {
        children: {
          props: { history },
        },
      } = props;
      history.push({
        pathname: `/program/${projectId}`,
      });
    } else {
      if (projectId) {
        if (currentProject?.showUseCase) {
          let blockStatus = sessionStorage
            .getItem("assetEditStatus")
            ?.split(",");
          if (sessionStorage.getItem("deploymentReady") === "false") {
            setAlertStatus(prevState => ({
              ...prevState,
              alertMessagePopupStatus: true,
              alertMessage:"Please configure the asset/assets to proceed further.",
            }));
            sessionStorage.setItem("page", "program");
          } else {
            let {
              children: {
                props: { history },
              },
            } = props;
            history.push({
              pathname: `/program/${projectId}`,
            });
          }
        } else {
          displayAlert(shellLayoutConst.VALIDATE_DER_ALERT);
        }
      } else {
        displayAlert(shellLayoutConst.PROJECT_USE_CASE_ALERT);
      }
    }
  };

  const navigateToSystem = () => {
    if (
      projectStatusData?.projectStatus === "COMPLETED" ||
      projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
    ) {
      let {
        children: {
          props: { history },
        },
      } = props;
      history.push({
        pathname: `/systems/${projectId}`,
      });
    } else {
      if (projectId) {
        if (currentProject?.showSystems) {
          let blockStatus = sessionStorage
            .getItem("assetEditStatus")
            ?.split(",");
            if (sessionStorage.getItem("deploymentReady") === "false") {
              setAlertStatus(prevState => ({
                ...prevState,
                alertMessagePopupStatus: true,
                alertMessage:"Please configure the asset/assets to proceed further.",
              }));
              sessionStorage.setItem("page", "system");
            } else if (
            status.enableProgramPage === true &&
            sessionStorage.getItem("programDataModified") === "true"
          ) {
            setPopUpStatus((prevState) => ({
              ...prevState,
              modifiedDataAlertPopupStatus: true,
            }));
            sessionStorage.setItem("page", "systems");
          } else if (
            sessionStorage.getItem("optimizationModified") === "true" ||
            sessionStorage.getItem("programPage") === "true"
          ) {
            displayAlert(shellLayoutConst.VALIDATE_USE_CASE_ALERT);
          } else {
            let {
              children: {
                props: { history },
              },
            } = props;
            history.push({
              pathname: `/systems/${projectId}`,
            });
          }
        } else {
          displayAlert(shellLayoutConst.VALIDATE_DER_ALERT);
        }
      } else {
        displayAlert(shellLayoutConst.PROJECT_SYSTEM_ALERT);
      }
    }
  };
  const navigateToBOM = () => {
    if (projectStatusData?.projectStatus === "COMPLETED") {
      let {
        children: {
          props: { history },
        },
      } = props;
      history.push({
        pathname: `/bom/${projectId}`,
      });
    } else {
      if (projectId) {
        if (currentProject?.showBOM) {
          let blockStatus = sessionStorage
            .getItem("assetEditStatus")
            ?.split(",");
            if (sessionStorage.getItem("deploymentReady") === "false") {
              setAlertStatus(prevState => ({
                ...prevState,
                alertMessagePopupStatus: true,
                alertMessage:"Please configure the asset/assets to proceed further.",
              }));
              setRoutePathURI("/assets");
              sessionStorage.setItem("page", "bom");
            } else if (
            status.enableProgramPage === true &&
            sessionStorage.getItem("programDataModified") === "true"
          ) {
            setPopUpStatus((prevState) => ({
              ...prevState,
              modifiedDataAlertPopupStatus: true,
            }));
            sessionStorage.setItem("page", "bom");
          } else {
            if (
              sessionStorage.getItem("optimizationModified") === "true" ||
              sessionStorage.getItem("programPage") === "true"
            ) {
              displayAlert(shellLayoutConst.VALIDATE_USE_CASE_ALERT);
            } else if (!currentProject?.showBOM) {
              displayAlert(shellLayoutConst.VALIDATE_SYSTEMS_ALERT);
            } else if (!currentProject?.showBOM) {
              displayAlert(shellLayoutConst.VALIDATE_TIMESYNC_ALERT);
            } else {
              let {
                children: {
                  props: { history },
                },
              } = props;
              history.push({
                pathname: `/bom/${projectId}`,
              });
            }
          }
        } else {
          displayAlert(shellLayoutConst.VALIDATE_DER_ALERT);
        }
      } else {
        displayAlert(shellLayoutConst.PROJECT_BOM_ALERT);
      }
    }
  };

  const navigateToDeploy = () => {
    if (
      projectStatusData?.projectStatus === "COMPLETED" ||
      projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
    ) {
      let {
        children: {
          props: { history },
        },
      } = props;
      history.push({
        pathname: `/deploy/${projectId}`,
      });
    } else {
      if (projectId) {
        if (currentProject?.showBOM) {
          let blockStatus = sessionStorage
            .getItem("assetEditStatus")
            ?.split(",");
          if (sessionStorage.getItem("deploymentReady") === "false") {
            setAlertStatus(prevState => ({
              ...prevState,
              alertMessagePopupStatus: true,
              alertMessage:"Please configure the asset/assets to proceed further.",
            }));
            setRoutePathURI("/assets");
            sessionStorage.setItem("page", "deploy");
          } else if (
            status.enableProgramPage === true &&
            sessionStorage.getItem("programDataModified") === "true"
          ) {
            setPopUpStatus((prevState) => ({
              ...prevState,
              modifiedDataAlertPopupStatus: true,
            }));
            sessionStorage.setItem("page", "deploy");
          } else {
            if (!currentProject?.showUseCase) {
              displayAlert(shellLayoutConst.VALIDATE_USE_CASE_ALERT);
            } else if (!currentProject?.showBOM) {
              displayAlert(shellLayoutConst.VALIDATE_SYSTEMS_ALERT);
            } else if (!currentProject?.showBOM) {
              displayAlert(shellLayoutConst.VALIDATE_TIMESYNC_ALERT);
            } else {
              let {
                children: {
                  props: { history },
                },
              } = props;
              history.push({
                pathname: `/deploy/${projectId}`,
              });
            }
          }
        } else {
          displayAlert(shellLayoutConst.VALIDATE_DER_ALERT);
        }
      } else {
        displayAlert(shellLayoutConst.PROJECT_DEPLOY_ALERT);
      }
    }
  };

  const resetEnable = () => {
    setStatus((prevState) => ({
      ...prevState,
      enableAssetPage: false,
      enableProgramPage: false,
      enableSystemPage: false,
      enableBOMPage: false,
      enableDeployPage: false,
      enableSecureArchitecturePage: false,
    }));
  };

  const blockStatusDisplay = (status, message) => {
    setModifiedStatus((prevState) => ({
      ...prevState,
      modifiedDataAlertAssetPopupStatus: status,
      modifiedDERName: message,
    }));
  };

  const allowToSaveModifiedDataAsset = () => {
    setModifiedStatus((prevState) => ({
      ...prevState,
      modifiedDataAlertAssetPopupStatus: false,
    }));
  };

  const closeDataModifiedAlertPopupAsset = () => {
    setModifiedStatus((prevState) => ({
      ...prevState,
      modifiedDataAlertAssetPopupStatus: false,
    }));
    sessionStorage.removeItem("derHistory");
    sessionStorage.removeItem("pvHistory");
    sessionStorage.removeItem("cbEvHistory");
    sessionStorage.removeItem("cbLoadHistory");
    sessionStorage.removeItem("cbAssetHistory");
    sessionStorage.removeItem("loadHistory");
    sessionStorage.removeItem("derStatus");
    sessionStorage.setItem("assetEditStatus", "");

    let {
      children: {
        props: { history },
      },
    } = props;
    let pathNameDynamic = sessionStorage.getItem("page");
    history.push({
      pathname: `/${pathNameDynamic}/${projectId}`,
    });
  };
 const allowToSaveDERModifiedData = ()=>{
  
  sessionStorage.setItem("toBeSavedDERDataAsDraft", true);
  setPopUpStatus(prevState => ({
    ...prevState,
    modifiedDERDataAlertPopupStatus: false,
  }));
  saveComponentDraftData();
  let {
    children: {
      props: { history },
    },
  } = props;
  history.push({
    pathname: `${routePathURI}/${projectId}`,
  });
 }
 const closeDataModifiedDERAlertPopup = () => {
  setPopUpStatus(prevState => ({
    ...prevState,
    modifiedDERDataAlertPopupStatus: false,
  }));
  let {
    children: {
      props: { history },
    },
  } = props;
  history.push({
    pathname: `${routePathURI}/${projectId}`,
  });
};

 
  const allowToDeleteModifiedData = () => {
    sessionStorage.setItem("toBeSavedAsDraft", true);
    setPopUpStatus((prevState) => ({
      ...prevState,
      modifiedDataAlertPopupStatus: false,
    }));

    setTimeout(() => {
      saveDraftData();
    }, 200);
    let {
      children: {
        props: { history },
      },
    } = props;
    let pathNameDynamic = sessionStorage.getItem("page");
 
    history.push({
      pathname: `/${pathNameDynamic}/${projectId}`,
    });
  };
  
  const saveComponentDraftData = ()=>{
    let componentData = JSON.parse(sessionStorage.getItem("componentJsonData"))
    const componentModified = sessionStorage.getItem("componentDataModified");
    if(componentModified ){
      apiSession
      .updateComponents(componentData)
      .then((response) => {
        sessionStorage.setItem("componentDataModified",false);
        // ComponentDataDispatch({
        //   type:ACTIONS.RESET_COMPONENT_DATA,
        //   payload:{}
        // })
      })
      .catch((error) => {});
    }else{
      callSnackbar("error", "Please enter mandatory fields");
    }
    
  }

  const saveDraftData = () => {
    if (UserScope.access.saveProgram === true) {
      let jsonData = sessionStorage.getItem("draftSave");
      if (jsonData !== null) {
        apiSession
          .saveDraftProgram(JSON.parse(jsonData))
          .then((response) => {
            sessionStorage.setItem("draftSave", null);
          })
          .catch((error) => {
            sessionStorage.setItem("draftSave", null);
          });
      }
    } else {
      sessionStorage.setItem("draftSave", null);
    }
  };

  const closeDataModifiedAlertPopup = () => {
    setPopUpStatus((prevState) => ({
      ...prevState,
      modifiedDataAlertPopupStatus: false,
    }));
    let {
      children: {
        props: { history },
      },
    } = props;
    let pathNameDynamic = sessionStorage.getItem("page") ?? "information"
    history.push({
      pathname: `/${pathNameDynamic}/${projectId}`,
    });
  };

  const displayAlert = async (message) => {
    // await apiSession
    //   .getProject(projectId)
    //   .then((json) => {

    //     seClientType(json.clientType)
    //   })
    //   .catch(() => {
    //     // setLoading(false);
    //   });

    setAlertStatus((prevState) => ({
      ...prevState,
      alertMessage: message,
      alertMessagePopupStatus: true,
    }));
  };

  const closeAlertPopup = () => {
    setAlertStatus((prevState) => ({
      ...prevState,
      alertMessage: "",
      alertMessagePopupStatus: false,
    }));

    //*for communication validation

    if (
      alertStatus.alertMessage === shellLayoutConst.VALIDATE_SYSTEMS_ALERT ||
      alertStatus.alertMessage === shellLayoutConst.VALIDATE_TIMESYNC_ALERT
    ) {
      let path =
        clientType === "A2E_PROJECT"
          ? `/program/${projectId}`
          : `/systems/${projectId}`;
      let {
        children: {
          props: { history },
        },
      } = props;
      history.push({
        pathname: path,
      });
    } else if (
      alertStatus.alertMessage === shellLayoutConst.VALIDATE_USE_CASE_ALERT
    ) {
      let {
        children: {
          props: { history },
        },
      } = props;
      history.push({
        pathname: `/program/${projectId}`,
      });
    }
  };
  
  const selectAllOption = () =>{
    return (
      currentProject?.showBOM &&
      currentProject?.showDeploy &&
      currentProject?.showAsset &&
      currentProject?.showSystems &&
      currentProject?.showUseCase
    );
  }

  const openGenerateReportConfiguration = () => {
    if (projectId) {
      setPopUpStatus((prevState) => ({ ...prevState, openReportPopUp: true }));

      setReportStatus((prevState) => ({
        ...prevState,
        selectAll: true,
        information: true,
        bom: currentProject?.showBOM,
        deploy: currentProject?.showDeploy,
        sld: true,
        system: currentProject?.showSystems && currentProject?.showDeploy,
        program: currentProject?.showUseCase && currentProject?.showSystems,
      }));
    } else {
      displayAlert("Project is not created.");
    }
  };

  const closeOpenReportPopUp = () => {
    setPopUpStatus((prevState) => ({ ...prevState, openReportPopUp: false }));
    setReportStatus((prevState) => ({
      ...prevState,
      selectAll: false,
      information: false,
      bom: false,
      deploy: false,
      sld: false,
      system: false,
      program: false,
      enableSecureAC: false,
      showSeletOption: false,
      loggedInUser: UserScope.name
    }));
    setStatus((prevState) => ({ ...prevState, reportReadyStatus: false }));
  };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;

    setReportStatus((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };
  const handleCheckBoxChangeAll = (e) => {
    const { checked } = e.target;
    setReportStatus((prevState) => ({
      ...prevState,
      selectAll: checked,
      information: checked,
      sld:  checked,
      bom:    currentProject?.showDeploy ? checked : false,
      deploy: currentProject?.showDeploy ? checked : false,
      system: currentProject?.showSystems ? checked : false,
      program: currentProject?.showUseCase ? checked : false,
    }));
  };

  const uploadReport = () => {
    const reports = [
      { key: "information", label: "Information" },
      { key: "sld", label: "Configure DER's" },
      { key: "program", label: "Configure usecases" },
      { key: "bom", label: "BOM" },
      { key: "system", label: "System settings" },
      { key: "deploy", label: "Deploy" },
    ];
    const filteredReports = reports
      .filter((r) => reportStatus[r.key]) // keep only those with true
      .reduce((obj, r, i) => {
        obj[`custom_cde_${i + 1}`] = r.label;
        return obj;
      }, {});
    if (Object.keys(filteredReports).length) {
      sendCommonEvent({
        event: "custom_interaction",
        interaction_name: "Download Report",
        interaction_location: "Generate Report",
        ...filteredReports,
      });
    }
 
    if (
      reportStatus.information === true ||
      reportStatus.sld === true ||
      reportStatus.program === true ||
      reportStatus.bom === true ||
      reportStatus.system === true ||
      reportStatus.deploy === true ||
      reportStatus.secureAC === true
    ) {
      setStatus((prevState) => ({ ...prevState, reportReadyStatus: true }));
      setPopUpStatus((prevState) => ({
        ...prevState,
        loadingPopupStatus: true,
      }));
    } else {
      setReportStatus((prevState) => ({
        ...prevState,
        showSeletOption: true,
        loggedInUser: UserScope?.name
      }));
    }
  };

  const uploadSLDStatus = (data) => {
    generateReport();
  };

  const isValidName = (value) =>
    /^[a-zA-Z0-9_-\s]*$/.test(value) ? true : false;

  const handleChangeName = (e) => {
    const { value } = e?.target
    if (isValidName(e?.target?.value)) {
      setReportStatus((prevState) => ({
        ...prevState,
        loggedInUser: value,
      }));
    }
  };

  const generateReport = () => {
    if (
      reportStatus.information === true ||
      reportStatus.sld === true ||
      reportStatus.program === true ||
      reportStatus.bom === true ||
      reportStatus.system === true ||
      reportStatus.deploy === true
    ) {
      if (projectId) {
        setPopUpStatus((prevState) => ({
          ...prevState,
          loadingPopupStatus: true,
        }));

        apiSession
          .generateReport({
            projectId: projectId,
            information: reportStatus.information,
            sld: reportStatus.sld,
            program: reportStatus.program,
            bom: reportStatus.bom,
            system: reportStatus.system,
            deploy: reportStatus.deploy,
            loggedInUser: reportStatus.loggedInUser
          })
          .then((response) => {
            setPopUpStatus((prevState) => ({
              ...prevState,
              loadingPopupStatus: false,
            }));
            closeOpenReportPopUp();
            FileDownload(
              response,
              "report.pdf",
              "application/pdf"
            );
             if(document.getElementsByClassName('sticky-button')[0]){
            document.getElementsByClassName('sticky-button')[0].style.display = "";
            }
            callSnackbar("success", "Report Downloaded successfully");
            setStatus((prevState) => ({
              ...prevState,
              reportReadyStatus: false,
            }));
            setReportStatus((prevState) => ({
              ...prevState,
              showSeletOption: false,
            }));
          })
          .catch((error) => {
            setPopUpStatus((prevState) => ({
              ...prevState,
              loadingPopupStatus: false,
            }));
            setStatus((prevState) => ({
              ...prevState,
              reportReadyStatus: false,
            }));
            closeOpenReportPopUp();
            callSnackbar("error", "Error in report download");
            if(document.getElementsByClassName('sticky-button')[0]){
            document.getElementsByClassName('sticky-button')[0].style.display = "";
            }
            setReportStatus((prevState) => ({
              ...prevState,
              showSeletOption: false,
            }));
          });
      }
    }
  };
  /* istanbul ignore next */
  const changePasswordConfirmation = (
    passwordCheck,
    newPassword,
    confirmPassword,
    oldPw
  ) => {
    if (
      passwordCheck === true &&
      confirmPassword.toLowerCase() === newPassword.toLowerCase()
    ) {
      let jsonBody = {
        oldPassword: oldPw,
        newPassword: newPassword,
      };
      apiSession
        .changePassword(jsonBody)
        .then(() => {
          setPopUpStatus((prevState) => ({
            ...prevState,
            changePasswordPopUpStatus: false,
            successChangePassword: true,
          }));
        })
        .catch((error) => {
          if (error.response !== undefined) {
            let { data } = error.response;
            callSnackbar("error", data.message);
            if (error.status === 403) {
              callSnackbar("error", data.message);
            } else if (error.status === 400) {
              callSnackbar("error", data.message);
            } else if (error.status === 500) {
              callSnackbar("error", data.message);
            } else {
              callSnackbar("error", data.message);
            }
          } else {
            callSnackbar("error", configLabel.layout.NetworkError);
          }
        });
    } else {
      callSnackbar("error", configLabel.layout.pwrdPolicyError);
    }
  };
  /* istanbul ignore next */
  const redirectTologin = () => {
    let {
      children: {
        props: { history },
      },
    } = props;
    setPopUpStatus((prevState) => ({
      ...prevState,
      successChangePassword: false,
    }));

    history.push({
      pathname: "/",
    });
  };
  /* istanbul ignore next */

  const adminRoleClickHandler = () => {
    setPopUpStatus((prevState) => ({
      ...prevState,
      adminRolePopStatus: true,
    }));
  };
  /* istanbul ignore next */
  const closeAddSubrole = () =>
    setPopUpStatus((prevState) => ({
      ...prevState,
      adminRolePopStatus: false,
    }));
  /* istanbul ignore next */
  const addSubRole = (subRole) => {
    closeAddSubrole();
    setPopUpStatus((prevState) => ({
      ...prevState,
      logoutPopUpStatus: true,
    }));

    apiSession.changeTempRole(subRole).then(() => {
      setTimeout(() => {
        setPopUpStatus((prevState) => ({
          ...prevState,
          logoutPopUpStatus: false,
        }));
        onButtonLogout();
      }, 1500);
    });
  };

   const callSnackbar = useCallback((type, message) => {
     try {
       setSnackBar({ type, message });
       snackBarRef.current.open = true
     } catch (error) {
       console.log("error in snack bar")
     }
   }, []);
const enableDarkTheme = () => {
  const appElement = document.getElementsByTagName('se-app')[0];
  const currentTheme = appElement.getAttribute('theme');

  if (currentTheme === 'light') {
    appElement.setAttribute('theme', 'dark');
    setCurrentProject(prevData=>{
      return {...prevData,
         isDarkMode: true}
    })
    setDarkData({
      themeType: 'Dark',
      color: 'primary'
    });
  } else {
    appElement.setAttribute('theme', 'light');
     setCurrentProject(prevData=>{
      return {...prevData,
         isDarkMode: false}
    })
    setDarkData({
      themeType: 'Light',
      color: 'secondary'
    });
  }
};
const enableHelMenu = () => {
  const currentPage = props?.children?.props?.history?.location?.pathname;
  if (!currentProject.enableHelpMenu) {
    setCurrentProject((prevData) => ({
      ...prevData,
      enableHelpMenu: true,
      pathName:currentPage,
    }));
  } else {
    setCurrentProject((prevData) => ({
      ...prevData,
      enableHelpMenu: false,
      pathName:currentPage,
    }));
  }
};
  let pname = sessionStorage.getItem("pname");
  let pType = sessionStorage.getItem("pType");

  return (
    <se-container position="absolute" direction="column">
      {/* {currentProject.enableHelpMenu && <HelpMenu pathName = {currentProject.pathName}/>} */}

      <div style={{ position: "sticky", top: 0, zIndex: 109 }}>
        <se-header app-title="Microgrid Build">
          <se-sidemenu
            id="app2-sidemenu"
            style={
              UserScope.name !== "" ? { height: "100vh" } : { display: "none" }
            }
          >
            <se-sidemenu-item
              item="Projects"
              ref={projectNavigationRef}
            ></se-sidemenu-item>

            {UserScope.access.getUsers === true && (
              <se-sidemenu-item
                item="User Management"
                ref={userNavigationRef}
              ></se-sidemenu-item>
            )}

            {UserScope.access.saveAssets === true && (
              <se-sidemenu-item
                item="Library Management"
                ref={libraryNavigationRef}
              ></se-sidemenu-item>
            )}

            {UserScope.access.globalParams === true && (
              <se-sidemenu-item
                item="Global Parameters"
                ref={globalNavigationRef}
              ></se-sidemenu-item>
            )}

            {UserScope.access.audit === true && (
              <se-sidemenu-item item="Analytics" ref={analyticsNavigationRef}>
                AAA
              </se-sidemenu-item>
            )}
            <se-sidemenu-item item="Legal" ref={legalRef}>
              <div className="col-md-12">
                <div className="border mt-2 p-2 legal-border">
                  <h4>Schneider Data Privacy Policy</h4>
                  <a
                    href={privacyPolicy}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Legal Policy"
                  >
                    <h5>{privacyPolicy}</h5>
                  </a>
                </div>
              </div>
            </se-sidemenu-item>
            <se-sidemenu-item item="Contact" ref={contactNavigationRef}>
              <Contact />
            </se-sidemenu-item>
            <se-sidemenu-item item="Privacy Preferences" ref={privacyRef} className="ot-sdk-show-settings" id="privacy">
              </se-sidemenu-item>
          </se-sidemenu>

          <div className="internal__Rnd">{env.REACT_APP_R_D}</div>
          {false && (
            <div slot="end" className="d-flex align-item-center pt-2 pr-2">
              <label className="dark-switch">
                <input
                  type="checkbox"
                  checked={darkData?.themeType === "Light" ? false : true}
                  className="dark-input"
                  onChange={enableDarkTheme}
                />
                <span className="dark-slider"></span>
              </label>
             

            </div>

          )}
          {false && (
            <div slot="end">
              <se-icon color="secondary" onClick={enableHelMenu}>
                information_circle
              </se-icon>
            </div>
          )}
          <div
            slot="end"
            style={UserScope.name !== "" ? {} : { display: "none" }}
          >
            {/* <span color="red"> 
           
            <se-icon color={darkData?.color} onClick={enableDarkTheme}>
           light_on
            </se-icon></span> */}

            <se-dropdown alignment="right">
              <se-button
                slot="trigger"
                option="inherit"
                icon="user_standard"
                icon-color="primary"
              >
                {UserScope.name}
              </se-button>
              <se-list option="dropdown">
                <se-list-item
                  item={"Role : " + UserScope.role}
                  onClick={
                    UserScope.access.changeTempRole
                      ? adminRoleClickHandler
                      : undefined
                  }
                ></se-list-item>
                <se-divider></se-divider>
                <se-list-item
                  onClick={redirectToProfile}
                  item="Profile"
                ></se-list-item>
                <se-divider></se-divider>
                <se-list-item
                  onClick={onChangePassword}
                  item="Change password"
                ></se-list-item>
                <se-divider></se-divider>

                <se-list-item
                  onClick={onButtonLogout}
                  item="Logout"
                ></se-list-item>
              </se-list>
            </se-dropdown>
          </div>
        </se-header>

        <se-tabbar color="primary">
          <nav style={status.navStatus ? {} : { display: "none" }}>
            <span
              className={`ml-3 ${
                window.location.pathname === `/information/${projectId}` ||
                window.location.pathname === `/information/new`
                  ? "active"
                  : ""
              }`}
              onClick={navigateToInformation}
            >
              <span className="se-subHeader-16px text-capitalize se-custom-nav-header">
                <span className="ml-1"> INFORMATION </span>
              </span>
            </span>

            <span className="mr-0 no-events">
              {" "}
              Design{" "}
              <se-icon className="icon_button icon_28 mr-1">
                arrow2_right
              </se-icon>
            </span>

            {status.enableAssetPage === true ? (
              <NavLink
                to={`/assets/${projectId}`}
                activeClassName="active"
                className={`ml-0 ${
                  !currentProject?.showAsset ? "disabled-nav" : ""
                }`}
                disabled={!currentProject?.showAsset}
              >
                <span className="se-subHeader text-capitalize">
                  <se-icon className="icon_button icon_20 " size="nano">
                    circuit_breaker
                  </se-icon>
                  <span className="ml-1"> Configure DERs </span>
                </span>
              </NavLink>
            ) : (
              <span
                className={`ml-0 ${
                  !currentProject?.showAsset ? "disabled-nav" : ""
                }`}
                onClick={navigateToAsset}
                disabled={!currentProject?.showAsset}
              >
                <span className="se-subHeader text-capitalize">
                  <se-icon className="icon_button icon_20 " size="nano">
                    circuit_breaker
                  </se-icon>
                  <span className="ml-1"> Configure DERs </span>
                </span>
              </span>
            )}

            {status.enableProgramPage === true ? (
              <NavLink
                to={`/program/${projectId}`}
                activeClassName="active"
                className={`ml-0 ${
                  !currentProject?.showUseCase ? "disabled-nav" : ""
                }`}
                disabled={!currentProject?.showUseCase}
              >
                <span className="se-subHeader text-capitalize">
                  <se-icon className="icon_button icon_20 " size="nano">
                    sensors
                  </se-icon>
                  <span className="ml-1"> Configure Use Cases </span>
                </span>
              </NavLink>
            ) : (
              <span
                className={`ml-0 ${
                  !currentProject?.showUseCase ? "disabled-nav" : ""
                }`}
                onClick={navigateToProgram}
                disabled={!currentProject?.showUseCase}
              >
                <span className="se-subHeader text-capitalize">
                  <se-icon className="icon_button icon_20 " size="nano">
                    sensors
                  </se-icon>
                  <span className="ml-1"> Configure Use Cases </span>
                </span>
              </span>
            )}

            {status.enableSystemPage === true ? (
              <NavLink
                to={`/systems/${projectId}`}
                activeClassName="active"
                className={`ml-0 ${
                  !currentProject?.showSystems ? "disabled-nav" : ""
                }`}
                disabled={!currentProject?.showSystems}
              >
                <span className="se-subHeader text-capitalize">
                  <se-icon className="icon_button icon_20 " size="nano">
                    connection_ethernet
                  </se-icon>
                  <span className="ml-1"> Systems </span>
                </span>
              </NavLink>
            ) : (
              <span
                className={`ml-0 ${
                  !currentProject?.showSystems ? "disabled-nav" : ""
                }`}
                onClick={navigateToSystem}
                disabled={!currentProject?.showSystems}
              >
                <span className="se-subHeader text-capitalize">
                  <se-icon className="icon_button icon_20 " size="nano">
                    connection_ethernet
                  </se-icon>
                  <span className="ml-1"> Systems </span>
                </span>
              </span>
            )}
            {/* {status.enableSecureArchitecturePage === true ? (
            <NavLink
              to="/secureArchitecture"
              activeClassName="active"
              className="ml-0"
            >
              <span className="se-subHeader text-capitalize">

                Secure Architecture
              </span>

            </NavLink>
          ) : (
            <span className="ml-0" onClick={navigateToSecureArchitecture}>
              <span className="se-subHeader text-capitalize">
                Secure Architecture
              </span>
            </span>
          )} */}

            {status.enableBOMPage === true ? (
              <NavLink
                to={`/bom/${projectId}`}
                exact={true}
                activeClassName="active"
                className={`ml-0 ${
                  !currentProject?.showBOM ? "disabled-nav" : ""
                }`}
                disabled={!currentProject?.showBOM}
              >
                B.O.M
              </NavLink>
            ) : (
              <span
                className={`ml-0 ${
                  !currentProject?.showBOM ? "disabled-nav" : ""
                }`}
                onClick={navigateToBOM}
                disabled={!currentProject?.showBOM}
              >
                <span className="se-subHeader-14px  se-custom-nav-header">
                  <span className="ml-1"> B.O.M </span>
                </span>
              </span>
            )}

            {status.enableDeployPage === true ? (
              <NavLink
                to={`/deploy/${projectId}`}
                exact={true}
                activeClassName="active"
                className={`ml-0 ${
                  !currentProject?.showDeploy ? "disabled-nav" : ""
                }`}
                disabled={!currentProject?.showDeploy}
              >
                DEPLOY
              </NavLink>
            ) : (
              <span
                className={`ml-0 ${
                  !currentProject?.showDeploy ? "disabled-nav" : ""
                }`}
                onClick={navigateToDeploy}
                disabled={!currentProject?.showDeploy}
              >
                <span className="se-subHeader-14px text-capitalize se-custom-nav-header">
                  <span className="ml-1"> DEPLOY </span>
                </span>
              </span>
            )}

            <span
              className={`ml-0 ${
                props?.children?.props?.history?.location?.pathname ===
                "/information/new"
                  ? "disabled-nav"
                  : ""
              }`}
              disabled={
                props?.children?.props?.history?.location?.pathname ===
                "/information/new"
                  ? true
                  : false
              }
              onClick={openGenerateReportConfiguration}
            >
              <span className="se-subHeader-14px text-capitalize se-custom-nav-header">
                <span className="ml-1"> GENERATE REPORT </span>
              </span>
            </span>
          </nav>
          <nav
            slot="edge"
            overflow="compact"
            className=" no-events se-subHeader-14px se-green-background se-custom-nav-header "
            style={{height:"100%"}}
          >
            <div
              className="truncate-projectName-header d-flex flex-column"
              style={{ width: "333px" }}
              title={currentProject?.projectStatus?.projectName}
            >
              {currentProject?.projectStatus?.projectName && (
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {" "}
                  Project Name :{" "}
                  <span>{currentProject?.projectStatus?.projectName}</span>
                </span>
              )}
              {currentProject?.projectStatus?.projectType && (
                <span>
                  <span className="mr-2">Project Type</span>
                  <span>: {currentProject?.projectStatus?.projectType}</span>
                </span>
              )}
            </div>
          </nav>
        </se-tabbar>
      </div>
      {props.children}

      {popUpStatus?.changePasswordPopUpStatus && (
        <ChangePassword
          closeChangePasswordPopUp={closeChangePasswordPopUp}
          changePasswordConfirmation={changePasswordConfirmation}
        />
      )}

      {popUpStatus?.openReportPopUp && (
        <GenerateReport
          status={status}
          reportStatus={reportStatus}
          closeOpenReportPopUp={closeOpenReportPopUp}
          handleCheckBoxChange={handleCheckBoxChange}
          handleCheckBoxChangeAll={handleCheckBoxChangeAll}
          uploadReport={uploadReport}
          uploadSLDStatus={uploadSLDStatus}
          handleChangeName={handleChangeName}
        />
      )}

      <se-dialog
        id="AlertDialog"
        open={modifiedStatus?.modifiedDataAlertAssetPopupStatus}
        can-backdrop="false"
      >
        <se-dialog-header>Alert</se-dialog-header>
        <se-dialog-content
          icon="information_circle"
          color="primary"
          className="se-header-font-size-16px se-life-green"
        >
          Modified data is not saved in {modifiedStatus?.modifiedDERName}. Do you
          want to save ? if No, Modified data will be lost.
        </se-dialog-content>
        <se-dialog-footer>
          <se-button onClick={allowToSaveModifiedDataAsset}>Yes</se-button>
          <se-button onClick={closeDataModifiedAlertPopupAsset}>No</se-button>
        </se-dialog-footer>
      </se-dialog>

      <se-dialog
        id="AlertDialog"
        open={popUpStatus?.modifiedDataAlertPopupStatus}
        can-backdrop="false"
      >
        <se-dialog-header>Alert</se-dialog-header>
        <se-dialog-content
          icon="information_circle"
          color="primary"
          className="se-header-font-size-16px se-life-green"
        >
          Modified data is not saved. Do you want to save data? if yes, Modified
          data will be saved as draft.
        </se-dialog-content>
        <se-dialog-footer>
          <se-button onClick={allowToDeleteModifiedData}>Yes</se-button>
          <se-button onClick={closeDataModifiedAlertPopup}>No</se-button>
        </se-dialog-footer>
      </se-dialog>

      <se-dialog
        id="AlertDialog"
        open={popUpStatus?.modifiedDERDataAlertPopupStatus}
        can-backdrop="false"
      >
        <se-dialog-header>Alert</se-dialog-header>
        <se-dialog-content
          icon="information_circle"
          color="primary"
          className="se-header-font-size-16px se-life-green"
        >
          {popUpStatus?.message}
        </se-dialog-content>
        <se-dialog-footer>
          <se-button onClick={allowToSaveDERModifiedData}>Yes</se-button>
          <se-button onClick={closeDataModifiedDERAlertPopup}>No</se-button>
        </se-dialog-footer>
      </se-dialog>

      <se-dialog
        id="AlertDialog"
        open={alertStatus?.alertMessagePopupStatus}
        can-backdrop="false"
      >
        <se-dialog-header>Alert</se-dialog-header>
        <se-dialog-content
          icon="information_circle"
          color="primary"
          className="se-header-font-size-16px se-life-green"
        >
          {alertStatus?.alertMessage}
        </se-dialog-content>
        <se-dialog-footer>
          <se-button onClick={closeAlertPopup}>OK</se-button>
        </se-dialog-footer>
      </se-dialog>

      <se-dialog
        id="AlertDialog"
        open={redirectAlert?.alertPopUpStatus}
        can-backdrop="false"
      >
        <se-dialog-header>{redirectAlert?.title}</se-dialog-header>
        <se-dialog-content
          icon="information_circle"
          color="primary"
          className="se-header-font-size-16px se-life-green"
        >
          {redirectAlert?.message}
        </se-dialog-content>
        <se-dialog-footer>
          <se-button onClick={closeRedirectAlertPopup}>OK</se-button>
        </se-dialog-footer>
      </se-dialog>

      <se-dialog
        id="AlertDialog"
        open={popUpStatus?.loadingPopupStatus}
        can-backdrop="false"
      >
        <se-dialog-content
          color="primary"
          className="se-header-font-size-16px se-life-green"
        >
          Please Wait Report is generating...
        </se-dialog-content>
      </se-dialog>

      <se-dialog
        id="AlertDialog"
        open={popUpStatus?.logoutPopUpStatus}
        can-backdrop="false"
      >
        <se-dialog-content
          color="primary"
          className="se-header-font-size-16px se-life-green"
        >
          You will be logged out of the Application. Please Re-login.
        </se-dialog-content>
      </se-dialog>

      <se-dialog
        id="dialog-asset-select-alert"
        size="small"
        can-backdrop="false"
        open={popUpStatus?.successChangePassword}
      >
        <se-dialog-content icon="information_stroke" icon-color="primary">
          Password changed Successfully, Please login with new password.
        </se-dialog-content>
        <se-dialog-footer>
          <se-button onClick={redirectTologin}>OK</se-button>
        </se-dialog-footer>
      </se-dialog>

      {popUpStatus?.adminRolePopStatus && (
        <AdminRoles
          currentRole={UserScope.role}
          closeAddSubrole={closeAddSubrole}
          addSubRole={addSubRole}
        />
      )}

      <se-snackbar
        id="snackbar-shell"
        type={snackBar.snackbarType}
        icon="information_stroke"
        message={snackBar.snackbarMessage}
        duration="3000"
      ></se-snackbar>
      <Snackbar snackBar={snackBar} ref={snackBarRef} />
    </se-container>
  );
};

export default withRouter(ShellLayout);
